import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";

export const mailMeFields = Object.freeze([
    {
        name:"mailMeBackoffice",
        icon:MailOutlineOutlinedIcon
    },
    {
        name:"mailMeGameNews",
        icon:NotificationsNoneOutlinedIcon
    },
    {
        name:"mailMeMarketing",
        icon:CampaignOutlinedIcon
    }
]);
